import "./style.css"

<const/techItems=(
  input.stack
    ? input.stack.split(', ')
    : input.libraries
    ? input.libraries.split(', ')
    : []
)/>

<div class="project-card">
  <if=input.image>
    <div class="project-card-image">
      <img src=input.image alt=input.alt_text />
    </div>
  </if>
  <div class="project-card-content">
    <span class=`project-badge project-badge--${input.project_type}`>
      ${input.project_type === 'arduino' ? 'Arduino / Maker' : 'Web'}
    </span>
    <h3 class="project-card-title">${input.title}</h3>
    <p class="project-card-desc">${input.project_desc}</p>
    <if=techItems.length>
      <div class="project-card-tags">
        <for|tech| of=techItems>
          <span class="tech-tag">${tech}</span>
        </for>
      </div>
    </if>
    <div class="project-card-links">
      <if=input.client_repo>
        <a rel="noreferrer" target="_blank" href=input.client_repo aria-label=`${input.title} client repository`>
          Client Repo
        </a>
      </if>
      <if=input.server_repo>
        <a rel="noreferrer" target="_blank" href=input.server_repo aria-label=`${input.title} ${input.project_type === 'arduino' ? 'GitHub' : 'server'} repository`>
          ${input.project_type === 'arduino' ? 'GitHub Repo' : 'Server Repo'}
        </a>
      </if>
      <if=input.host>
        <a rel="noreferrer" target="_blank" href=input.host aria-label=`${input.title} live demo`>
          Live Demo
        </a>
      </if>
    </div>
  </div>
</div>
